module.exports = __webpack_public_path__ + "8fa73e30b044920b334411494bfd0c01.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/gingerbread-house.png
// module id = 573
// module chunks = 0